// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLinesListHeaderStyles } from "@synd/Overrides/Components/CartLinesListHeader";
import LinkEdit from "@synd/XDL/Icons/LinkEdit";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color, createLinkIconStyles, mergeWithCss, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

cartLinesListHeaderStyles.wrapper = {
    ...mergeWithCss(cartLinesListHeaderStyles.wrapper, {
        css: css`
            border-bottom: none;
            border-top: 1px solid ${color("common.border")};
            padding: 24px 0 16px;
            align-items: baseline;
            ${xScreen("lte", "md")} {
                border-bottom: none;
                align-items: end;
            }
        `,
    }),
};

cartLinesListHeaderStyles.titleContainer = {
    css: css`
        display: flex;
        gap: 24px;
        align-items: baseline;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            align-items: start;
            gap: 16px;
        }
    `,
};

cartLinesListHeaderStyles.productCountText = {
    variant: "h3",
    color: "common.ui7",
    css: css`
        margin: 0;
    `,
};

cartLinesListHeaderStyles.editLink = {
    ...createLinkIconStyles({
        icon: LinkEdit,
        sizeVariant: "xsmall",
        variant: "primary",
        linkStyles: {
            css: css`
                justify-content: flex-end;
                margin-top: 4px;
            `,
            icon: {
                iconProps: {
                    size: 12,
                },
            },
        },
    }),
};

cartLinesListHeaderStyles.casesCount = {
    ...fontConfig.xSmallSingleLine,
    weight: fontConfig.weight.semiBold,
};
